
import authHeader from "./auth-header";
import interceptors, { instanceAxios } from "./interceptors";

//API_URL_BASE = window.Config.host + '/api/api';
//const API_URL_BASE = 'http://10.63.0.152:8080/api';

class BaseServices {

  addResult(body) {
    return instanceAxios.post(window.Configs.URLSERVER + '/api/AddResult', body, { headers: authHeader() });
  }
  
  getCode(body) {
    return instanceAxios.post(window.Configs.URLSERVER + '/api/GetCode', body, { headers: authHeader() });
  }

  getSurvey(body) {
    return instanceAxios.post(window.Configs.URLSERVER + '/api/GetSurvey', body, { headers: authHeader() });
  }
  
  getEmpleyoee(body) {
    return instanceAxios.post(window.Configs.URLSERVER + '/api/GetEmpleyoee', body, { headers: authHeader() });
  }

  getMyResults(body) {
    return instanceAxios.post(window.Configs.URLSERVER + '/api/GetMyResults', body, { headers: authHeader() });
  }

  getAllResults(body) {
    return instanceAxios.post(window.Configs.URLSERVER + '/api/GetAllResults', body, { headers: authHeader() });
  }  

  setStatus(body) {
    return instanceAxios.post(window.Configs.URLSERVER + '/api/SetStatus', body, { headers: authHeader() });
  }
  getLogMessage(body) {
    return instanceAxios.post(window.Configs.URLSERVER + '/api/GetLogMessage', body, { headers: authHeader() });
  }  
  addLogMessage(body) {
    return instanceAxios.post(window.Configs.URLSERVER + '/api/AddLogMessage', body, { headers: authHeader() });
  }   
  sendMail(body) {
    return instanceAxios.post(window.Configs.URLSERVER + '/api/SendMail', body, { headers: authHeader() });
  }    
}

export default new BaseServices();
